import { render, staticRenderFns } from "./addNoticeCompent.vue?vue&type=template&id=5ea439c8"
import script from "./addNoticeCompent.vue?vue&type=script&lang=js"
export * from "./addNoticeCompent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports